export interface IonResultInterface {
  detail: {
    role: string;
  };
}
